import { Navigation } from './Navigation';
import './App.css';


function App() {
  return (
    <Navigation />
  );
}

export default App;
